import { CircularProgress, DialogTitle, Stack } from "@mui/material";
import { CloseIcon } from "../../assets/Icons";
import { useTheme } from "styled-components";
import {
  CloseIconWrapper,
  FontGrayNormal,
  ModalTitle,
  StyledContainedButton,
  StyledDialog,
  StyledOutlinedButton,
} from "../modals/style";

const CancelRenewalModal = ({
  handleCancelRenewal,
  isLoading,
  handleClose,
  open,
}: {
  handleCancelRenewal: () => void;
  isLoading: boolean;
  handleClose: () => void;
  open: boolean;
}) => {
  const theme = useTheme();

  const handleConfirm = () => {
    handleCancelRenewal(); // Consider renaming to `handleCancelRenewal()` for clarity
  };

  return (
    <StyledDialog onClose={handleClose} open={open} maxWidth="md" fullWidth>
      <Stack
        sx={{ padding: "1.25rem 1.875rem 1.25rem 1.25rem", gap: "1.875rem" }}
      >
        <DialogTitle>
          <Stack direction="row" gap="0.75rem" alignItems="start">
            <Stack gap={"0.625rem"}>
              <ModalTitle>Cancel Renewal?</ModalTitle>
              <FontGrayNormal>
                This action will cancel the auto-renewal of your subscription.
                You will still have access to the service until the end of your
                current billing cycle.
              </FontGrayNormal>
            </Stack>
          </Stack>
          <CloseIconWrapper aria-label="close" onClick={handleClose}>
            <CloseIcon />
          </CloseIconWrapper>
        </DialogTitle>

        <Stack
          direction="row"
          alignItems="center"
          gap="0.625rem"
          sx={{ marginLeft: "auto" }}
        >
          <StyledOutlinedButton
            variant="outlined"
            size="small"
            padding="0.313rem 1.5rem"
            onClick={handleClose}
          >
            Keep Renewal
          </StyledOutlinedButton>
          <StyledContainedButton
            variant="contained"
            size="small"
            background={theme.colors.red200}
            sx={{ padding: "0.313rem 1.5rem" }}
            disabled={isLoading}
            startIcon={
              isLoading && <CircularProgress size={20} color="inherit" />
            }
            onClick={handleConfirm}
          >
            Cancel Renewal
          </StyledContainedButton>
        </Stack>
      </Stack>
    </StyledDialog>
  );
};

export default CancelRenewalModal;
